// src/stone/icons/DollarInvoicePay.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarInvoicePay = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M12 3a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1" }),
      /* @__PURE__ */ jsx("path", { d: "M10.877 5.062c1.81-.224 3.893.184 5.088.812a1 1 0 1 1-.93 1.77c-.805-.423-2.473-.775-3.912-.597-.709.088-1.253.292-1.6.576-.308.25-.523.61-.523 1.22 0 .444.193.753.75 1.074.594.343 1.407.58 2.398.869l.132.038c.973.284 2.123.627 3.02 1.218.966.637 1.7 1.604 1.7 3.051 0 1.195-.502 2.128-1.303 2.77-.763.613-1.745.923-2.704 1.055-1.896.261-4.118-.122-5.473-.864a1 1 0 0 1 .96-1.754c.929.508 2.707.848 4.24.637.756-.105 1.345-.329 1.725-.634.342-.274.555-.64.555-1.21 0-.633-.266-1.029-.8-1.38-.603-.398-1.453-.669-2.48-.969l-.217-.063c-.902-.261-1.94-.562-2.753-1.032C7.807 11.105 7 10.234 7 8.843c0-1.193.472-2.128 1.258-2.77.747-.609 1.703-.897 2.619-1.01" })
    ]
  }
);
var DollarInvoicePay_default = DollarInvoicePay;

export {
  DollarInvoicePay_default
};
